import { EVENT, pushEvent } from "Services/googleAnalytics";

export default function handlePageView(data) {
    if (!data.name || !data.user_country || !data.user_language || data.referral_id === undefined) {
        throw new Error("Missing required property!");
    }

    pushEvent({
        event: EVENT.VIRTUAL_PAGE_VIEW,
        page_location: window.location.origin + window.location.pathname + window.location.search + window.location.hash,
        virtual_page_location: window.location.origin + window.location.pathname + data.name + window.location.search,
        page_origin: window.location.origin + window.location.pathname + window.location.hash,
        virtual_page_origin: window.location.origin + window.location.pathname + data.name,
        virtual_page_name: data.name,
        user_country: data.user_country,
        user_language: data.user_language,
        referral_id: data.referral_id
    });
}



// WEBPACK FOOTER //
// ./src/services/googleAnalytics/eventHandlers/pageView.js